export default "__VITE_ASSET___qmRdris__"